import(/* webpackMode: "eager" */ "/app/src/components/pages/guest-books/Client.tsx")